module.exports = __webpack_public_path__ + "img/2-click-import.996dee1a.png";